enum ErrorCauses {
    INSUFFICIENT_PLAN = 'insufficient_plan',
  }

export default ErrorCauses;
